//首页-tab列表
export const tabList = [
  {
    name: '首页',
    path: 'Home',
    icon: `${require('@/assets/style/home-icon.png')}`,
    activeIcon: `${require('@/assets/style/home-active-icon.png')}`,
    id:1
  },
  {
    name: '我的',
    path: 'My',
    icon: `${require('@/assets/style/my-icon.png')}`,
    activeIcon: `${require('@/assets/style/my-active-icon.png')}`,
    id:2
  }
]
//首页-描述列表
export const describeList = [
  {
    id:1,
    name:'高额度',
    icon: `${require('@/assets/style/high-amount-icon.png')}`
  },
  {
    id:2,
    name:'低利息',
    icon: `${require('@/assets/style/low-interest-icon.png')}`
  },
  {
    id:3,
    name:'速放贷',
    icon: `${require('@/assets/style/fast-loan-icon.png')}`
  },
]
//引导列表
export const guideList = [
  {
    id:1,
    name:'持牌正规机构',
    icon: `${require('@/assets/style/agency-icon.png')}`
  },
  {
    id:2,
    name:'可成长额度',
    icon: `${require('@/assets/style/credit-limit-icon.png')}`
  },
  {
    id:3,
    name:'客服',
    icon: `${require('@/assets/style/artificial-icon.png')}`
  },
 ]
 //我的-菜单列表
 export const menuList = [
  {
    id:1,
    name:'意见反馈',
    icon: `${require('@/assets/style/feedback-icon.png')}`,
    path:'feedBack'
  },
  {
    id:2,
    name:'检查更新',
    icon: `${require('@/assets/style/system-update-icon.png')}`,
    path:'CheckUpdate'
  },
  {
    id:3,
    name:'下载APP',
    icon: `${require('@/assets/style/App-icon.png')}`,
    path:'Download'
  },
   {
    id:4,
    name:'设置',
    icon: `${require('@/assets/style/settings-icon.png')}`,
    path:'Settings'
  },
 ]
 //设置列表
 export const settingList = [
  {
    id:1,
    name:'协议信息',
    icon: `${require('@/assets/style/protocol-icon.png')}`,
  },
  {
    id:2,
    name:'账户与安全',
    icon: `${require('@/assets/style/account-icon.png')}`,
  },
]
//我的-信息-tab列表
export const infoTabList = [
  {
    id:1,
    name:'实名认证',
  },
  {
    id:2,
    name:'添加联系人',
  },
  {
    id:3,
    name:'个人信息',
  },
]
//协议列表
export const protocolList = {
  "login":[
    {
      id:1,
      name:'《用户协议》',
      key:'userAgreement',
    },
    {
      id:2,
      name:'《隐私协议》',
      key:'frivacyAgreement',
    },
  ],
  "idCardBinding":[
    {
      id:1,
      name:'《实名认证授权同意书》',
    },
    {
      id:2,
      name:'《数据查询授权说明书》',
    },
    {
      id:3,
      name:'《敏感个人信息授权书》',
    },
    {
      id:4,
      name:'《征信查询授权书》',
    },
    {
      id:5,
      name:'《非学生身份承诺函》',
    },
    {
      id:6,
      name:'《人脸验证个人信息授权协议》',
    },
  ],
  "loan":[
    {
      id:1,
      name:'《借款合同》',
    },
     {
      id:2,
      name:'《担保合同》',
    },
    {
      id:3,
      name:'《债权转让协议》',
    },
    {
      id:4,
      name:'《债权转让通知书》',
    },
  ],
  "bankCardBinding":[
    {
      id:1,
      name:'《委托代发代扣协议》',
    },
  ],
}
//首页借款成功提示
export const loanSuccessTip = [
  {
    id:1,
    name:'用户178****01成功打款¥3000',
  },
  {
    id:2,
    name:'用户157****08成功打款¥1000',
  },
  {
    id:3,
    name:'用户182****02成功打款¥4000',
  },
  {
    id:4,
    name:'用户183****05成功打款¥1000',
  },
  {
    id:5,
    name:'用户166****07成功打款¥2000',
  },
]
//通知-tab列表
export const notifyTabList = [
  {
    id:0,
    name:'活动消息',
    img: `${require('@/assets/style/Announcement-icon.png')}`,
    activeImg: `${require('@/assets/style/Announcement-active-icon.png')}`,
  },
  {
    id:1,
    name:'服务消息',
    img: `${require('@/assets/style/service-message-icon.png')}`,
    activeImg: `${require('@/assets/style/service-message-active-icon.png')}`,
  },
]
//借款用途列表
export const applicationList = [
  {
    id:1,
    name:'个人消费',
    icon: `${require('@/assets/style/personalConsumption-icon.png')}`,
    isChecked:false,
  },
  {
    id:2,
    name:'其他用途',
    icon: `${require('@/assets/style/otherUses-icon.png')}`,
    isChecked:false,
  },
]
export const pageCardList = [
  {
    icon: `${require('@/assets/style/card-dialog-icon1.png')}`,
    title: "信息安全加密",
    id: 1,
  },
  {
    icon: `${require('@/assets/style/approval-icon.png')}`,
    title: "审批智能快速",
    id: 2,
  },
  {
    icon: `${require('@/assets/style/speed-icon.png')}`,
    title: "放贷安全极速",
    id: 3,
  },
]
export const warrantyStatementList = [
  {
    id:1,
    name:'用户信息保密',
    icon: `${require('@/assets/style/secret-icon.png')}`,
    desc:'严谨加密算法，谨防信息泄漏',
  },
  {
    id:2,
    name:'资金流动合法',
    icon: `${require('@/assets/style/funds-icon.png')}`,
    desc:'资金来源合法，借贷过程安全',
  },
  {
    id:3,
    name:'保障用户权益',
    icon: `${require('@/assets/style/user-icon.png')}`,
    desc:'平台真实可靠，保障用户权益',
  },
]
//处理后端返回的错误码
export const errorCodeList = [
  {
    id:10004,
    name:'用户黑名单',
  },
  {
    id:10005,
    name:'用户灰名单',
  },
  {
    id:10006,
    name:'可用额度不足',
  },
  {
    id:10007,
    name:'额度不够最小借贷金额',
  },
  {
    id:10008,
    name:'超出订单上限',
  },
  {
    id:10009,
    name:'准入不通过',
  },
  {
    id:10010,
    name:'风控不通过',
  },
  {
    id:10011,
    name:'资质认证未通过',
  },
  {
    id:10012,
    name:'有未结清订单数',
  },
  {
    id:10013,
    name:'个人信息未通过',
  },
  {
    id:10014,
    name:'联系人信息未通过',
  },
]
//通知类型列表
//1.准入通过 2.准入不通过 3.风控通过 4.风控不通过 5.放款成功 6.放款失败 7.账单还款成功 8.订单完结 9.意见反馈处理
export const notifyTypeList = {
  '1': {
    name: '准入通过',
    icon: `${require('@/assets/style/approve.png')}`,
  },
  '2': {
    name: '准入不通过',
    icon: `${require('@/assets/style/fail-icon.png')}`,
  },
  '3': {
    name: '风控通过',
    icon: `${require('@/assets/style/approve.png')}`,
  },
  '4': {
    name: '风控不通过',
    icon: `${require('@/assets/style/fail-icon.png')}`,
  },
  '5': {
    name: '放款成功',
    icon: `${require('@/assets/style/successfully.png')}`,
  },
  '6': {
    name: '放款失败',
    icon: `${require('@/assets/style/fail-icon.png')}`,
  },
  '7': {
    name: '账单还款成功',
    icon: `${require('@/assets/style/successfully.png')}`,
  },
  '8': {
    name: '订单完结',
    icon: `${require('@/assets/style/approve.png')}`,
  },
  '9': {
    name: '意见反馈处理',
    icon: `${require('@/assets/style/notifyL-icon.png')}`,
  },
}
//订单状态类型
export const orderStatusList = {
  1:"待还",
  2:"逾期",
}
//信息错误码处理
export const infoErrorCode = [10011,10012,10013,10014,10016,10023]
//特殊处理人员状态错误码
export const infoStatusErrorCode = [10004,10005,10006,10008,10011]
//特殊处理code
export const specialCodes = [10001,10002,10003,10004,10005,10006,10007,10008,10009,10010,10011,10012,10013,10014,10015,10017,10018,10021];
export const dayList = ['1','2','3','4','5','6','7','8','9','10','11','12','13','14','15','16','17','18','19','20','21','22','23','24','25','26','27','28','29','30','31']

